import { Location01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react-native';
import type { WithResponsive } from '@sunrise-ui/primitives';
import {
  Colors,
  TextReg,
  formatTimeRange,
  useDynamicStyles,
} from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, View } from 'react-native';

type Props = {
  startDate?: string;
  endDate?: string;
  formattedTime?: string | null;
  formattedDate?: string | null;
  locationName?: string;
  isLoadingLocation?: boolean;
  actions?: React.ReactNode;
};

export function SessionTimeLocationActions({
  startDate,
  endDate,
  formattedTime,
  formattedDate,
  locationName,
  isLoadingLocation,
  actions,
}: Props) {
  const styles = useDynamicStyles(createStyles);
  const timeRange = formattedTime || formatTimeRange(startDate, endDate);

  return (
    <View style={styles.topRow}>
      <View style={styles.leftColumn}>
        {formattedDate && (
          <TextReg style={styles.timeRange}>{formattedDate}</TextReg>
        )}
        {timeRange && <TextReg style={styles.timeRange}>{timeRange}</TextReg>}
        {isLoadingLocation ? (
          <View style={styles.locationSkeleton} />
        ) : locationName ? (
          <View style={styles.locationContainer}>
            <HugeiconsIcon
              icon={Location01Icon}
              size={14}
              color={Colors.text}
              style={styles.locationIcon}
            />
            <TextReg style={styles.timeRange} numberOfLines={1}>
              {locationName}
            </TextReg>
          </View>
        ) : null}
      </View>
      {actions && <View style={styles.buttonsContainer}>{actions}</View>}
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    topRow: {
      flexDirection: 'row',
      gap: isMobile ? 4 : 16,
      width: '100%',
      alignItems: 'flex-start',
    },
    leftColumn: {
      flex: 1,
      flexDirection: 'column',
      minWidth: 0,
      overflow: 'hidden',
    },
    buttonsContainer: {
      flexDirection: 'row',
      gap: 12,
      alignItems: 'center',
      marginLeft: 'auto',
      zIndex: 100,
      alignSelf: 'flex-start',
      position: 'relative',
      flexShrink: 0,
    },
    timeRange: {
      fontSize: isMobile ? 12 : 14,
      color: Colors.text,
      opacity: 0.8,
    },
    locationContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    locationIcon: {
      opacity: 0.8,
    },
    locationSkeleton: {
      width: '100%',
      maxWidth: 200,
      height: isMobile ? 12 : 14,
      marginTop: 2.75,
      marginBottom: 2.75,
      borderRadius: 16,
      backgroundColor: Colors.opacity20,
    },
  });
